import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable, Input, Output } from '@angular/core';
import { of } from 'rxjs';
import { tap, catchError, retry, map } from 'rxjs/operators';
import { AnalyticsService } from './device.analytics.service';
import { CookieHandlerService } from './cookieHandler.service';
import { EmitterService } from './emitter.service';
// import { GeoLocationService } from './geoLocation.service';
import { CommonConstants } from './../utilities/commonConstants';
// import { SharedService } from './sharedService';
import { Formatter } from './formatter';
import { RouteContextProvider } from './routeContextProvider.service';
import { SessionHandlerService } from './sessionHandler.service';
import { adobe_analytics_service } from './adobe_analytics_service';
import { Observable, Subject } from 'rxjs';
import { SharedService } from './sharedService';
@Injectable({
  providedIn: 'root'
})
export class HttpInterceptor {
  @Input() public listId: string;
  private _appCOID: string;
  private _constantID: string;
  private timeoutId: any;
  isMobile: any;
  authToken: any;
  private newTime: Date = new Date();
  public static UUID(): string {
    if (typeof (window.crypto) !== 'undefined'
      && typeof (window.crypto.getRandomValues) !== 'undefined') {
      const buf: Uint16Array = new Uint16Array(8);
      window.crypto.getRandomValues(buf);
      return (this.pad4(buf[0]) + this.pad4(buf[1]) + ' ' + this.pad4(buf[2])
        + ' ' + this.pad4(buf[3]) + ' ' + this.pad4(buf[4]) + ' ' + this.pad4(buf[5])
        + this.pad4(buf[6]) + this.pad4(buf[7]));
    } else {
      return this.random4() + this.random4() + ' '
        + this.random4() + ' ' + this.random4() + ' ' +
        this.random4() + ' ' + this.random4() + this.random4() + this.random4();
    }
  }
  private static pad4(num: number): string {
    let ret: string = num.toString(16);
    while (ret.length < 4) {
      ret = '0' + ret;
    }
    return ret;
  }
  private static random4(): string {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  constructor(
    private _http: HttpClient,
    private _analyticsService: AnalyticsService,
    private _cookieHandler: CookieHandlerService,
    private _formatter: Formatter,
    private _routeContextProvider: RouteContextProvider,
    private _emitterService: EmitterService,
    private _sessionHandlerService: SessionHandlerService,
    private _adobe_analytics_service: adobe_analytics_service,
    private sharedService: SharedService
  ) {
    this.CaptureLogData();
  }
  public Get(url: string, hideLoader?: boolean, options?: HttpHeaders, removeSessionid?: boolean):
    Observable<ActivitiModel.MTResponse<any>> {
    const defaultOptions = this.tasksBeforeCall(options, hideLoader, removeSessionid);
    return this._http.get<ActivitiModel.MTResponse<any>>(url, defaultOptions)
      .pipe(
        retry(0),
        tap(response => {
          this.emitIsLoadingStatus(false);
        }),
        catchError((error, caught) => {
          if (error.status === 440) {
            this._emitterService.Get(CommonConstants.EmitterEventTypes.SessionExpired).emit(true);
          }
          this.emitIsLoadingStatus(false);
          this.handleError(error);
          if (!this.sharedService.isBFLJourney()) {
            this._adobe_analytics_service.triggerAPIFailureService(error.error, url);
          }
          return of(error);
        })
      );
  }
  public Post(url: string, data: any, hideLoader?: boolean, options?: HttpHeaders, removeSessionid?: boolean):
    Observable<ActivitiModel.MTResponse<any>> {
    const defaultOptions = this.tasksBeforeCall(options, hideLoader, removeSessionid);
    return this._http.post<ActivitiModel.MTResponse<any>>(url, data, defaultOptions)
      .pipe(
        retry(0),
        tap(response => {
          if (!response === null) {
            // let mtResponse: Model.MTResponse<any> = response.json();
            this.emitIsLoadingStatus(false);
            if (response.progressInfo && response.progressInfo.payload
              && response.progressInfo.payload.length > 0) {
              this._emitterService
                .Get(CommonConstants.EmitterEventTypes.ProgressStateEvent)
                .emit(response.progressInfo.payload);
            }
          } else {
            this._emitterService
              .Get(CommonConstants.EmitterEventTypes.ProgressStateEvent)
              .emit(response);
          }
        }),
        catchError((error, caught) => {
          if (error.status === 440) {
            console.log(error)
            this._emitterService.Get(CommonConstants.EmitterEventTypes.SessionExpired).emit(true);
          }
          this.emitIsLoadingStatus(false);
          this.handleError(error);
          if (!this.sharedService.isBFLJourney()) {
            this._adobe_analytics_service.triggerAPIFailureService(error.error, url);
          }
          return of(error);
        })
      );
  }
  public Put(url: string, data: any, hideLoader?: boolean, options?: HttpHeaders):
    Observable<Response> {
    const defaultOptions = this.tasksBeforeCall(options, hideLoader);
    return this._http.put<Response>(url, data, defaultOptions)
      .pipe(
        tap((response) => {
          // let mtResponse: Model.MTResponse<any> = response.json();
          this.emitIsLoadingStatus(false);
          /* if (mtResponse.progressInfo && mtResponse.progressInfo.payload
              && mtResponse.progressInfo.payload.length > 0) {
              this._emitterService
                  .Get(CommonConstants.EmitterEventTypes.ProgressStateEvent)
                  .emit(mtResponse.progressInfo.payload);
          } */
        }),
        catchError((error, caught) => {
          this.emitIsLoadingStatus(false);
          this.handleError(error);
          if (!this.sharedService.isBFLJourney()) {
            this._adobe_analytics_service.triggerAPIFailureService(error.error, url);
          }
          return of(error);
        })
      );
  }
  /*** Only to fetch the aem link */
  public GetAem(url: string, hideLoader?: boolean):
    Observable<any> {
    return this._http.get(url);
  }
  // this captures the browser, time, location details, session if any, OS or  device details
  public CaptureLogData() {
    let OSName = 'Unknown OS';
    if (navigator.appVersion.indexOf('Win') !== -1) { OSName = 'Windows'; }
    if (navigator.appVersion.indexOf('Mac') !== -1) { OSName = 'MacOS'; }
    if (navigator.appVersion.indexOf('X11') !== -1) { OSName = 'UNIX'; }
    if (navigator.appVersion.indexOf('Linux') !== -1) { OSName = 'Linux'; }
    if (navigator.appVersion.indexOf('Android') !== -1) { OSName = 'Android'; }
    if (navigator.appVersion.indexOf('iPhone') !== -1) { OSName = 'iPhone'; }
    const deviceDetails: DeviceDetails = this._analyticsService.GetDeviceDetails();
    this._sessionHandlerService.SetSession('DeviceDetails', JSON.stringify(deviceDetails));
  }
  public GetPollingRetry(url: string, hideLoader?: boolean, options?: HttpHeaders, processId?: string):
    Observable<ActivitiModel.MTResponse<any>> {
    const defaultOptions: any = {
      ...this.tasksBeforeCall(options, hideLoader),
      responseType: 'text' // Get raw text to allow decryption interceptor to work
    };
    const processid = processId ? processId : '';
    return this._http.get(url, defaultOptions).pipe(
      map((response: any) => {
        // If response is a string, try to parse it as JSON
        if (typeof response === 'string') {
          try {
            return JSON.parse(response);
          } catch (e) {
            return response;
          }
        }
        return response;
      })
    ) as Observable<ActivitiModel.MTResponse<any>>;
  }
  public applicationTokensPost(url: string, data?: any, hideLoader?: boolean, options?: HttpHeaders, mode?: boolean):
    Observable<any> {
    const defaultOptions = this.applicationTasksBeforeCall(options, hideLoader);
    if (mode) {
      return this._http.get<any>(url, defaultOptions)
        .pipe(
          map((res) => {
            return {
              payload: res.body.payload,
              headers: res.headers,
              nextTask: res.body.nextTask,
              errors: res.body.errors
            };
          }),
          catchError((error) => {
            this.handleError(error);
            if (!this.sharedService.isBFLJourney()) {
              this._adobe_analytics_service.triggerAPIFailureService(error.error, url);
            }
            return of(error);
          })
        );
    } else {
      return this._http.post<any>(url, data, defaultOptions)
        .pipe(
          map((res) => {
            if(url.includes('federatedlogin')) {
              return {
                payload: res.body,
                headers: res.headers,
                nextTask: res.body.nextTask,
                errors: res.body.errors,
                status: res.status
              };
            } else {
              return {
                payload: res.body.payload,
                headers: res.headers,
                nextTask: res.body.nextTask,
                errors: res.body.errors,
                status: res.status
              };
            }

          }),
          catchError((error) => {
            this.handleError(error);
            this._adobe_analytics_service.triggerAPIFailureService(error.error, url);
            return of(error);
          })
        );
    }
  }
  private createID() {
    return HttpInterceptor.UUID();
  }
  private getHeaders = (customOptions: HttpHeaders, removeSessionid?: boolean): HttpHeaders => {
    const sessionId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.sessionId);
    this.isMobile = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.IsMobile);
    this.authToken = this.isMobile === '1' ? this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.PSVToken) : this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.JWToken);

    if (this.createGuardTokenOnRequest()) {
      let headerObj: HttpHeaders;
      const newHeadObj = {
        'Content-Type': 'application/json',
        'cmptcorrid': this._constantID + '|' + this.createID(),
        'authtoken': this.authToken,
        'guardtoken': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.GuardToken),
        'processId': this._formatter.removeDoubleQuotes(this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId)),
        'x-audit-loc-latitude': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.latitude) ? this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.latitude) : '',
        'x-audit-loc-longitude': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.longitude) ? this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.longitude) : '',

      };
      if (customOptions && customOptions.keys()) {
        customOptions.keys().forEach((key: string) => {
          headerObj.set(key, customOptions.get(key));
        });
      }
      if ((removeSessionid !== null && removeSessionid) || !sessionId) {
        headerObj = new HttpHeaders(newHeadObj);

      } else {
        newHeadObj[CommonConstants.CookieKeys.sessionId] = sessionId;
        headerObj = new HttpHeaders(newHeadObj);
      }
      console.log('headerObj');
      console.log(headerObj);
      return headerObj;
    }
  }
  private handleError(error: Response | any) {
    this.listId = '1';
    if (error.status === '400' ||
      error.status === '0' ||
      error.status === '504' ||
      error.status === '403' ||
      error.status === 400 ||
      error.status === 0 ||
      error.status === 504 ||
      error.status === 403) {
      /* this._emitterService.Get(CommonConstants.EmitterEventTypes.GlobalErrorEvent)
          .emit('Application' + error.status); */
    }
    // tslint:disable-next-line:no-console
    console.debug('Service level failure Details-->' + error.status);
  }
  private emitIsLoadingStatus(loadingStatus: boolean) {
    // this._emitterService.Get(CommonConstants.EmitterEventTypes.LoadingEvent)
    //     .emit(loadingStatus);
  }
  // genarate CookieKeys for GuardKey always on each
  // Request to make sure that token is not going to exprire
  private createGuardTokenOnRequest() {
    const newGuardToken = this._formatter.ConvertGuradKeyToGuardToken(
      this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.GuardKey));
    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardToken,
      newGuardToken);
    return true;
  }

  private tasksBeforeCall(options: HttpHeaders, hideLoader: boolean, removeSessionid?: boolean) {
    // this is specific in case don't want to show loader with main app
    if (hideLoader) {
      this.emitIsLoadingStatus(false);
    } else {
      this.emitIsLoadingStatus(true);
    }
    return {
      withCredentials: false,
      headers: this.getHeaders(options, removeSessionid)
    };
  }
  private applicationTasksBeforeCall(options: HttpHeaders, hideLoader: boolean) {
    // let formattedProcessId = this._formatter.removeDoubleQuotes(this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId));
    // formattedProcessId ? this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.processId, formattedProcessId) : undefined;

    return {
      headers: this.getHeaders(options),
      observe: 'response' as 'response'
    };
  }
  public getEventSource(url: string, hideLoader?: boolean): EventSource {
    // const defaultOptions = this.tasksBeforeCall(hideLoader);
    const authtoken = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.JWToken);
    url = url.replace('{authtoken}', authtoken);
    return new EventSource(url);
  }
}
